import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { CMSLink } from '../v2/components/CMSLink'
import { Form, Page, Resource } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import ModalForm from '../v2/components/ModalForm'
import { cn } from '../lib/utils'
import { RESOURCE_URL } from '@telesoft/lib/web/constants'
import { Button } from '../v2/components/ui/button'

export type SplitCTABlockProps = Extract<Page['blocks'][0], { blockType: 'split-cta' }>

export default function SplitCTA(block: SplitCTABlockProps): ReactElement {
  const { items } = block
  const isItems = items && items.length > 1

  return (
    <Container>
      <Grid>
        {items &&
          items.map((item, i: number) => {
            const { options, link } = item
            const CTAType = item.type

            const resource = item?.resource as Resource | undefined
            const isResourceWalled = resource?.isWalled
            const downloadUrl = RESOURCE_URL + '/' + resource?.filename

            return (
              <div
                key={`items-map-${i}`}
                className={`col-span-full ${
                  isItems ? 'md:col-span-4 lg:col-span-6' : null
                } flex justify-center items-stretch ${
                  options?.color ? options.color : 'bg-accent-1'
                } p-8 md:p-12 lg:p-20`}
              >
                <div
                  className={`flex flex-col justify-between items-start ${
                    isItems ? 'max-w-md' : null
                  } w-full`}
                >
                  <div className="flex flex-col justify-start items-start w-full">
                    <h5>{item.subTitle}</h5>
                    <div className="h-[1px] my-2 lg:my-8 bg-heading w-full" />
                    <Text variant="subHeading" className="text-black">
                      {item.title}
                    </Text>
                    <Text variant="body" className=" text-opacity-70 text-black lg:mt-10">
                      {item.description}
                    </Text>
                  </div>
                  <hr className="my-4" />
                  {CTAType === 'form' ? (
                    <ModalForm
                      formMessage="Please fill in your information below."
                      cmsForm={item.form as Form}
                      buttonLabel={item.label}
                      buttonProps={{
                        className: 'w-full',
                        variant: options?.color === 'bg-telesoft' ? 'outline' : 'default',
                      }}
                    />
                  ) : CTAType === 'download' ? (
                    <>
                      {isResourceWalled ? (
                        <ModalForm
                          cmsForm={resource.form as Form}
                          formMessage={`Download ${resource.name}`}
                          buttonLabel={item.label}
                          resourceID={resource.id}
                          buttonProps={{
                            className: 'w-full',
                            variant: options?.color === 'bg-telesoft' ? 'outline' : 'default',
                          }}
                        />
                      ) : (
                        <Button
                          asChild
                          variant={options?.color === 'bg-telesoft' ? 'outline' : 'default'}
                        >
                          <a href={downloadUrl} target="_blank">
                            Download Now
                          </a>
                        </Button>
                      )}
                    </>
                  ) : (
                    <CMSLink {...link} className={cn(`w-full`, {})} />
                  )}
                </div>
              </div>
            )
          })}
      </Grid>
    </Container>
  )
}
